import { Component, OnInit } from '@angular/core';
import { PortalConfigurationService } from '@services/portal-configuration/portal-configuration.service';
import { ResponseDataBase } from '@interfaces/index.interface';
import { AppConstants } from '@app/appConstants';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ResourceService } from '../../../../services/resource/resource.service';


@Component({
  selector: 'portal-parameters-page',
  templateUrl: './portal-parameters.page.html'
})
export class PortalParametersPage implements OnInit {

  ppconfiguration: FormGroup;
  editItem;

  constructor(public _portalConfigurationService: PortalConfigurationService,
    public _resourceService: ResourceService) {
    this.ppconfiguration = new FormGroup({
      mainColor: new FormControl(),
      secondaryColor: new FormControl(),
      backgroundColor: new FormControl(),
      logoBackgroundColor: new FormControl(),
      logoURL: new FormControl(),
      faviconURL: new FormControl(),
      name: new FormControl(),
      address: new FormControl(),
      phoneNumber: new FormControl(),
      email: new FormControl(),
      loginAttempsBeforeBlock: new FormControl(),
      tokenTimeoutMinutes: new FormControl(),
      logoUploadFile: new FormControl(),
      faviconUploadFile: new FormControl(),
      maxMonthsSearch: new FormControl('', [Validators.min(0), Validators.max(10)]),
      percentageFreeslotsShowed: new FormControl(),
      pinExpirationDays: new FormControl('', [Validators.min(0), Validators.max(30)]),
      maintenanceMode: new FormControl(this._portalConfigurationService.configuration?.maintenanceMode?.name == 'true'),
      textOnMaintenanceMode: new FormControl(),
      messageInPortal: new FormControl(this._portalConfigurationService.configuration?.messageInPortal?.name == 'true'),
      textOnMessageInPortal: new FormControl(),
      usersForMaintenanceMode: new FormControl(),
    });
    this.ppconfiguration.disable();
  }

  edit(portalParameterName) {
    this.ppconfiguration.controls[portalParameterName].enable();
    this.editItem = portalParameterName;
  }

  cancelEdit() {
    delete this._portalConfigurationService.alert;
    this._portalConfigurationService.getPortalParameters();
    this.ppconfiguration.disable();
    delete this.editItem;
  }

  update(portalParameter) {
    var logoURLInput: any = document.getElementById('logoURL');
    var faviconURLInput: any = document.getElementById('faviconURL');
    if (portalParameter.id == 'LOGO_URL' && logoURLInput) {
      this.upoloadLogoFile();
    } else if (portalParameter.id == 'FAVICON_URL' && faviconURLInput) {
      this.upoloadFaviconFile();
    } else {
      if (portalParameter == 'maintenanceMode') {
        if (this.ppconfiguration.controls.maintenanceMode.value) {
          this._portalConfigurationService.configuration.maintenanceMode.name = 'true';
        } else {
          this._portalConfigurationService.configuration.maintenanceMode.name = 'false';
        }
        portalParameter = this._portalConfigurationService.configuration.maintenanceMode;
      }
      if (portalParameter == 'messageInPortal') {
        if (this.ppconfiguration.controls.messageInPortal.value) {
          this._portalConfigurationService.configuration.messageInPortal.name = 'true';
        } else {
          this._portalConfigurationService.configuration.messageInPortal.name = 'false';
        }
        portalParameter = this._portalConfigurationService.configuration.messageInPortal;
      }
      this._portalConfigurationService.updatePortalParameter(portalParameter).subscribe(data => {
        let response = data as ResponseDataBase;
        if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
          this.cancelEdit();
        } else {
          this._portalConfigurationService.alert = "Error updating parameter";
        }
        this._portalConfigurationService.loading = false;
      });
    }
  }

  putNameInField() {
    if (this.ppconfiguration.value.logoUploadFile) {
      var filename = this.ppconfiguration.value.logoUploadFile.replace(/^.*[\\\/]/, '')
      document.getElementById("fileLabel").innerHTML = filename;
    }
  }

  upoloadLogoFile() {
    console.log('upoloadLogoFile');
    delete this._portalConfigurationService.alert;
    var input: any = document.getElementById('logoURL');
    var file = input.files[0];
    if (this._resourceService.isFileImage(input.files[0])) {
      console.log('1');
      var reader: any = new FileReader();
      let self = this;
      reader.onloadend = function () {
        var logoFile: any = reader.result.replace(/^data:.+;base64,/, '');
        let params = {
          logoFile: logoFile,
          name: input.files[0].name
        }
        self._portalConfigurationService.upoloadLogoFile(params).subscribe(data => {
          let response = data as ResponseDataBase;
          self._portalConfigurationService.loading = false;
          if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
            self.cancelEdit();
          } else {
            self._portalConfigurationService.alert = response.METADATA.ERROR_MESSAGE;
          }
          self._portalConfigurationService.loading = false;
        });
      };
      reader.readAsDataURL(file);
    } else {
      console.log('2');
      this._portalConfigurationService.alert = "ONLY_IMAGES_ALLOWED";
    }
  }

  upoloadFaviconFile() {
    delete this._portalConfigurationService.alert;
    var input: any = document.getElementById('faviconURL');
    var file = input.files[0];
    if (this._resourceService.isFileImage(input.files[0])) {
      var reader: any = new FileReader();
      let self = this;
      reader.onloadend = function () {
        var faviconFile: any = reader.result.replace(/^data:.+;base64,/, '');
        let params = {
          faviconFile: faviconFile,
          name: input.files[0].name
        }
        self._portalConfigurationService.upoloadFaviconFile(params).subscribe(data => {
          let response = data as ResponseDataBase;
          self._portalConfigurationService.loading = false;
          if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
            self.cancelEdit();
          } else {
            self._portalConfigurationService.alert = response.METADATA.ERROR_MESSAGE;
          }
          self._portalConfigurationService.loading = false;
        });
      };
      reader.readAsDataURL(file);
    } else {
      this._portalConfigurationService.alert = "ONLY_IMAGES_ALLOWED";
    }
  }

  ngOnInit() {
  }

}
